import { Container } from '@/components/ui/Container'
import { Section } from '@/components/ui/Section'
import { siteConfig } from '@/config/site'
import { founderBio } from '@/constants/company'

export function FounderSection() {
  return (
    <Section surface="0">
      <Container className="max-w-4xl">
        <div className="rounded-sm border border-border bg-surface-1 p-5 sm:p-10 md:p-12 flex flex-col md:flex-row gap-6 sm:gap-8 items-start">
          <div className="flex-1">
            <span className="font-mono text-xs uppercase tracking-widest text-fg-muted mb-1.5 sm:mb-2 block">
              Leadership
            </span>
            <h2 className="text-xl sm:text-2xl font-bold tracking-tight text-fg">
              {siteConfig.founder.name}
            </h2>
            <p className="text-sm font-medium text-fg-muted mt-1">
              {siteConfig.founder.role}
            </p>
            <p className="mt-4 sm:mt-6 text-sm sm:text-base text-fg-subtle leading-relaxed">
              {founderBio}
            </p>
          </div>
        </div>
      </Container>
    </Section>
  )
}
